import { render, staticRenderFns } from "./XuTime.vue?vue&type=template&id=138f1e3a&scoped=true"
import script from "./XuTime.vue?vue&type=script&lang=js"
export * from "./XuTime.vue?vue&type=script&lang=js"
import style0 from "./XuTime.vue?vue&type=style&index=0&id=138f1e3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f1e3a",
  null
  
)

export default component.exports